import { theme } from "@chakra-ui/react"
import { smallSizes } from "./smallSizes"

export const space = {
  ...theme.space,
  ...smallSizes,
}
